var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManualIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8999 9.90039H4.8999M6.8999 13.9004H4.8999M12.8999 5.90039H4.8999M16.8999 5.70039V16.1004C16.8999 17.7805 16.8999 18.6206 16.5729 19.2624C16.2853 19.8268 15.8264 20.2858 15.2619 20.5734C14.6201 20.9004 13.7801 20.9004 12.0999 20.9004H5.6999C4.01974 20.9004 3.17967 20.9004 2.53793 20.5734C1.97344 20.2858 1.5145 19.8268 1.22688 19.2624C0.899902 18.6206 0.899902 17.7805 0.899902 16.1004V5.70039C0.899902 4.02023 0.899902 3.18015 1.22688 2.53842C1.5145 1.97393 1.97344 1.51499 2.53793 1.22737C3.17967 0.900391 4.01974 0.900391 5.6999 0.900391H12.0999C13.7801 0.900391 14.6201 0.900391 15.2619 1.22737C15.8264 1.51499 16.2853 1.97393 16.5729 2.53842C16.8999 3.18015 16.8999 4.02023 16.8999 5.70039Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManualIcon);
export default __webpack_public_path__ + "static/media/user-manual-icon.1b6f9a5e9374ad7c22335065b23e3c94.svg";
export { ForwardRef as ReactComponent };